import $ from 'jquery';
import Modal from '../classes/sleepy-modal.class';
import { URL_PARAMS } from '../utils/constants';

export default function modal() {
  const modals = {};

  $('.js-modal').each(function () {
    const modal = $(this).data('modal');

    modals[modal] = new Modal(this, {
      class: this.dataset.modalClass,
    });

    modals[modal].init();

    $(this).removeClass('is-hidden');
  });

  $(document).on('click', '.js-modal-trigger', function (e) {
    e.preventDefault();

    const modal = $(this).data('modal');

    if (modal === 'leave') {
      const href = $(this).attr('href');
      const target = $(this).attr('target');

      modals[modal].open();

      $('.js-modal[data-modal="leave"] .js-no-btn').on('click', () => {
        $('.sm-modal--active .js-modal[data-modal="leave"] .js-yes-btn').off();
        modals[modal].close();
      });

      $('.sm-modal--active .js-modal[data-modal="leave"] .js-yes-btn').on('click', () => {
        $('.sm-modal--active .js-modal[data-modal="leave"] .js-yes-btn').off();
        window.open(href, target);

        modals[modal].close();
      });
    } else {
      modals[modal].open();
    }
  });

  if ( URL_PARAMS.get('openTab') === 'inquiry' ) {
    modals.inquire.open();
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/project/modal.js